// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__91Oz3","header":"Messages_header__11v9_"};